import React, { useState } from "react";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";

export default function EditUserModal({ user, onClose, onUpdated }) {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);

  const save = async () => {
    try {
      await API.put(`/users/${user.id ?? user._id}`, { name, email });
      toast.success("Usuario actualizado");
      onUpdated();
      onClose();
    } catch {
      toast.error("Error actualizando usuario");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Editar usuario</h2>

        <input
          className="w-full px-3 py-2 border rounded mb-3"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nombre"
        />

        <input
          className="w-full px-3 py-2 border rounded mb-3"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Correo"
        />

        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-3 py-2 bg-gray-300 rounded-lg"
          >
            Cancelar
          </button>
          <button
            onClick={save}
            className="px-3 py-2 bg-supernova-500 text-white rounded-lg"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
